/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import { useAuth } from "context/AuthContext"

import routes from "routes.js";

function Header() {
  const location = useLocation();
  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };

  // 画面遷移
  const navigate = useNavigate();
  // 認証情報
  const auth = useAuth();

  // ログアウトボタン押下処理
  const handleOnClickLogout = () => {
    if (location?.state?.edited) {
      const confirmLeave = window.confirm('変更が保存されていません。本当に移動しますか？');
      if (!confirmLeave) {
        return;
      }
    }
    // 認証情報を削除
    auth.setAuth({
      isAuthed: false,
      access_token: ""
    });

    navigate("/login")

  }

  const getBrandText = () => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  return (
    <Navbar bg="light" expand="lg" className="m-0 px-0">
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ml-2 ml-lg-0">
          <Button
            variant="dark"
            className="d-lg-none btn-fill d-flex justify-content-center align-items-center rounded-circle p-2"
            onClick={mobileSidebarToggle}
          >
            <i className="fas fa-ellipsis-v"></i>
          </Button>
          <Navbar.Brand
            onClick={(e) => e.preventDefault()}
            className="mr-2"
          >
            {getBrandText()}
          </Navbar.Brand>
        </div>
        <div className="d-flex flex-row-reverse">
          <Button className="m-0 btn-fill" variant="secondary" size="sm" onClick={handleOnClickLogout}>ログアウト</Button>
          <div className="m-2">Ver.{process.env.REACT_APP_VERSION}</div>
        </div>
      </Container>
    </Navbar>
  );
}
export default Header;
